import { useEffect } from 'react';

interface BeforeInstallPromptEvent extends Event {
  readonly platforms: string[];
  readonly userChoice: Promise<{
    outcome: 'accepted' | 'dismissed';
    platform: string;
  }>;
  prompt(): Promise<void>;
}

declare global {
  interface WindowEventMap {
    beforeinstallprompt: BeforeInstallPromptEvent;
  }
}

// Notifies Android users that they can install the app.
// Will only show if it is not already installed.
// Which app to show is determined in "manifest.json".
export function useAndroidAppNotification() {
  useEffect(() => {
    const handle = (e: BeforeInstallPromptEvent) => {
      e.preventDefault();
      // Only prompt when the play store is available
      if (e.platforms.includes('play')) {
        document.addEventListener(
          'click',
          () => {
            e.prompt();
          },
          { once: true }
        );
      }
    };

    window.addEventListener('beforeinstallprompt', handle);
    return () => window.removeEventListener('beforeinstallprompt', handle);
  }, []);
}
